<script>
/* eslint-disable max-len */
  // Line icons (24×24 grid, stroke = currentColor) used across the assistant.
  const PATHS = {
    assistant:
      'M12 3l1.8 4.6L18.5 9l-4.7 1.8L12 15.5l-1.8-4.7L5.5 9l4.7-1.4L12 3zM18 15l.9 2.1L21 18l-2.1.9L18 21l-.9-2.1L15 18l2.1-.9L18 15z',
    chat: 'M5 5h14a2 2 0 012 2v8a2 2 0 01-2 2H10l-4 3v-3H5a2 2 0 01-2-2V7a2 2 0 012-2z',
    history: 'M3 12a9 9 0 103-6.7L3 8M3 3v5h5M12 7v5l3 2',
    plus: 'M12 5v14M5 12h14',
    settings:
      'M12 15a3 3 0 100-6 3 3 0 000 6zM19.4 15a1.7 1.7 0 00.3 1.8l.1.1a2 2 0 11-2.8 2.8l-.1-.1a1.7 1.7 0 00-1.8-.3 ' +
      '1.7 1.7 0 00-1 1.5V21a2 2 0 11-4 0v-.1a1.7 1.7 0 00-1.1-1.5 1.7 1.7 0 00-1.8.3l-.1.1a2 2 0 11-2.8-2.8l.1-.1a1.7 ' +
      '1.7 0 00.3-1.8 1.7 1.7 0 00-1.5-1H3a2 2 0 110-4h.1a1.7 1.7 0 001.5-1.1 1.7 1.7 0 00-.3-1.8l-.1-.1a2 2 0 112.8-2.8l.1.1a1.7 ' +
      '1.7 0 001.8.3H9a1.7 1.7 0 001-1.5V3a2 2 0 114 0v.1a1.7 1.7 0 001 1.5 1.7 1.7 0 001.8-.3l.1-.1a2 2 0 112.8 2.8l-.1.1a1.7 ' +
      '1.7 0 00-.3 1.8V9a1.7 1.7 0 001.5 1H21a2 2 0 110 4h-.1a1.7 1.7 0 00-1.5 1z',
    expand: 'M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7',
    collapse: 'M4 14h6v6M20 10h-6V4M14 10l7-7M3 21l7-7',
    close: 'M6 6l12 12M18 6L6 18',
    send: 'M4 12l16-8-6 16-2-7-8-1z',
    stop: 'M7 7h10v10H7z',
    resume: 'M4 12a8 8 0 0113.7-5.7L20 8M20 4v4h-4M20 12a8 8 0 01-13.7 5.7L4 16M4 20v-4h4',
    trash: 'M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3',
    edit: 'M4 20h4L19 9l-4-4L4 16v4zM13 7l4 4',
    check: 'M5 12l5 5L20 7',
    alert: 'M12 9v4M12 17h.01M10.3 3.9L2.4 18a2 2 0 001.7 3h15.8a2 2 0 001.7-3L13.7 3.9a2 2 0 00-3.4 0z',
    info: 'M12 22a10 10 0 100-20 10 10 0 000 20zM12 16v-4M12 8h.01',
    clock: 'M12 22a10 10 0 100-20 10 10 0 000 20zM12 6v6l4 2',
    search: 'M11 19a8 8 0 100-16 8 8 0 000 16zM21 21l-4.3-4.3',
    link: 'M10 14a5 5 0 007.1 0l3-3a5 5 0 00-7.1-7.1l-1.7 1.7M14 10a5 5 0 00-7.1 0l-3 3a5 5 0 007.1 7.1l1.7-1.7',
    external: 'M14 4h6v6M20 4l-9 9M18 14v5a1 1 0 01-1 1H5a1 1 0 01-1-1V7a1 1 0 011-1h5',
    chevron: 'M9 6l6 6-6 6',
    file: 'M14 3H7a2 2 0 00-2 2v14a2 2 0 002 2h10a2 2 0 002-2V8l-5-5zM14 3v5h5',
    report: 'M4 20V10M10 20V4M16 20v-7M22 20H2',
    computer: 'M4 4h16v11H4zM2 20h20M9 15v5M15 15v5',
    evidence: 'M9 12h6M9 16h6M9 8h2M5 3h10l4 4v14H5z',
    copy: 'M9 9h11v11H9zM5 15H4V4h11v1',
    flag: 'M5 21V4M5 4h11l-2 4 2 4H5',
    arrowIn: 'M19 5L5 19M5 9v10h10',
    arrowOut: 'M5 19L19 5M9 5h10v10',
    menu: 'M4 7h16M4 12h16M4 17h16',
    reset: 'M3 12a9 9 0 109-9 9.75 9.75 0 00-6.74 2.74L3 8M3 3v5h5',
    plug: 'M12 22v-5M9 8V2M15 8V2M18 8v5a4 4 0 01-4 4h-4a4 4 0 01-4-4V8z',
    key: 'M15.5 7.5l2.3 2.3a1 1 0 001.4 0l2.1-2.1a1 1 0 000-1.4L19 4M21 2l-9.6 9.6M7.5 22a5.5 5.5 0 100-11 5.5 5.5 0 000 11z',
    memory: 'M4 19.5A2.5 2.5 0 016.5 17H20M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2zM9 7h7M9 11h5',
    archive: 'M21 8v13H3V8M1 3h22v5H1zM10 12h4',
    page: 'M5 3h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2zM3 9h18M9 21V9',
    project: 'M4 7h16a1 1 0 011 1v11a1 1 0 01-1 1H4a1 1 0 01-1-1V8a1 1 0 011-1zM9 7V5a1 1 0 011-1h4a1 1 0 011 1v2M3 13h18',
    download: 'M12 4v11M7 10l5 5 5-5M5 20h14',
    upload: 'M12 15V4M7 9l5-5 5 5M5 20h14',
    paperclip: 'M21.44 11.05l-9.19 9.19a6 6 0 01-8.49-8.49l8.57-8.57A4 4 0 1118 8.84l-8.59 8.57a2 2 0 01-2.83-2.83l8.49-8.48',
  };

  export default {
    name: 'AiIcon',
    functional: true,
    props: {
      name: { type: String, required: true },
      size: { type: [Number, String], default: 16 },
    },
    render(h, { props, data }) {
      return h(
        'svg',
        {
          ...data,
          staticClass: ['ai-icon', data.staticClass].filter(Boolean).join(' '),
          attrs: {
            width: props.size,
            height: props.size,
            viewBox: '0 0 24 24',
            fill: 'none',
            stroke: 'currentColor',
            'stroke-width': 1.8,
            'stroke-linecap': 'round',
            'stroke-linejoin': 'round',
            'aria-hidden': 'true',
            focusable: 'false',
          },
        },
        [h('path', { attrs: { d: PATHS[props.name] || PATHS.info } })],
      );
    },
  };
</script>
